module.exports = __webpack_public_path__ + "static/media/icon-change-password.0da977cd.svg";